import { useMutation } from '@tanstack/react-query'

import { productUpdatesApi } from '../..'
import { SuccessResponse } from '../../productUpdateTypes'
import { MarkSeenResponse } from './markSeen.types'

const MARK_SEEN_MUTATION_KEY = 'MARK_SEEN'

const markSeen = async (materialId: string) => {
  const response = await productUpdatesApi.post<
    SuccessResponse<MarkSeenResponse>
  >(`/me/${materialId}/seen`)
  return response?.data?.data
}

export const useMarkSeenMutation = () => {
  return useMutation({
    mutationKey: [MARK_SEEN_MUTATION_KEY],
    mutationFn: markSeen
  })
}
